<template>
  <div class="kt-portlet kt-portlet--mobile">
    <!-- begin: Single Modal -->
    <router-view />
    <!-- end: Single Modal -->
    <!--begin::Form-->
    <form class="kt-form" ref="form">
      <div class="kt-portlet__head kt-portlet__head--lg">
        <div class="kt-portlet__head-label">
          <span class="kt-portlet__head-icon">
            <i class="kt-font-brand flaticon-home"></i>
          </span>
          <h3 class="kt-portlet__head-title">
            {{ this.$route.meta.breadcrumb }}
          </h3>
        </div>
      </div>
      <div class="kt-portlet__body">
        <div class="kt-section kt-section--first">
          <div class="row">
            <!-- Begin:วันที่ Check-In -->
            <div class="col-xl-4 col-lg-4 col-md-4">
              <div class="form-group">
                <label class="label">วันที่ Check-in :</label>
                <span class="form-control-plaintext">{{ checkInDate }}</span>
              </div>
            </div>
            <!-- End:วันที่ Check-In -->

            <!-- CR-PM-2026 Req 2: Begin:วันที่ Check-Out -->
            <div class="col-xl-4 col-lg-4 col-md-4">
              <div class="form-group">
                <label class="label">วันที่ Check-out :</label>
                <span class="form-control-plaintext">{{ checkOutDate || '' }}</span>
              </div>
            </div>
            <!-- End:วันที่ Check-Out -->

            <!-- Begin:ชื่อ-สกุลผู้ Check-In -->
            <div class="col-xl-4 col-lg-4 col-md-4">
              <div class="form-group">
                <label class="label">ชื่อ-สกุลผู้ Check-in :</label>
                <span class="form-control-plaintext">{{
                  checkInByUserFullName
                }}</span>
              </div>
            </div>
            <!-- End:ชื่อ-สกุลผู้ Check-In -->

            <!-- Begin:ร้านค้า -->
            <div class="col-xl-4 col-lg-4 col-md-4">
              <div class="form-group">
                <label class="label">ร้านค้า :</label>
                <span class="form-control-plaintext">{{ shopName }}</span>
              </div>
            </div>
            <!-- End:ร้านค้า -->

            <!-- Begin:ร้านค้า 2 -->
            <div class="col-xl-4 col-lg-4 col-md-4">
              <div class="form-group">
                <label class="label">ร้านค้า 2 :</label>
                <span class="form-control-plaintext">{{ shopName2 }}</span>
              </div>
            </div>
            <!-- End:ร้านค้า 2 -->
          </div>

          <div
            class="kt-section kt-section--first"
            v-for="(b, i) in barcodeShopMappings"
            :key="i"
          >
            <div class="row" >
              <div class="col-xl-6 text-left">
                <h3 v-if="!b.isDelete" class="kt-section__title">
                  {{ b.groupName }}
                </h3> 
              </div>
              
            </div>
            <div class="kt-section__body"   >
              <div class="row">
                <div class="col-sm-12 table-responsive">
                  <table
                    class="table table-sm table-striped table-bordered table-hover table-checkable"
                  >
                    <thead>
                      <tr> 
                        <th class="text-center" width="20%">ชื่อ</th>
                        <th class="text-center" width="15%">BARCODE </th> 
                        <th class="text-center" width="20%">รูปภาพ</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(row, j) in b.barcodeSets" :key="j"> 
                        <td class="stock-item-td text-center">
                          {{ row.productName }}
                        </td>
                        <td
                          class="text-center stock-item-td"
                          v-if="
                            row.barcodeNoOld == null
                          "
                        >
                          {{ row.barcodeNo }}
                        </td> 
                        <td class="text-center stock-item-td" 
                        v-if="
                            row.barcodeNoOld != null
                          ">
                          {{ row.barcodeNoOld }}
                        </td>
                        
                        <td class="text-center stock-item-td">
 
                          <a
                            href="#"
                            @click.prevent="pictureModal(row.fileUrl)"
                            title="รูปภาพ"
                            v-if="row.fileUrl != null && !row.isImgCloud"
                            >Link  </a
                          >
                          <a
                            href="javascript:void(0);"
                             @click="showModal(row.fileUrl)"
                            title="รูปภาพ"
                            v-if="row.fileUrl != null && row.isImgCloud"
                            >Link </a
                          >
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>


          <div
            class="kt-section kt-section--first"
            v-for="(b, i) in barcodeShopMappingsOther"
            :key="i"
          >
            <div class="row" >
              <div class="col-xl-6 text-left">
                <h3 v-if="!b.isDelete" class="kt-section__title">
                  {{ b.groupName }}
                </h3> 
              </div>
              
            </div>
            <div class="kt-section__body"   >
              <div class="row">
                <div class="col-sm-6 table-responsive">
                  <table
                    class="table table-sm table-striped table-bordered table-hover table-checkable"
                  >
                    <thead>
                      <tr>  
                        <th class="text-center" width="80%">BARCODE </th> 
                        <th class="text-center" width="20%">รูปภาพ</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(row, j) in b.barcodeSets" :key="j"> 
                        
                        <td
                          class="text-center stock-item-td"
                          v-if="
                            row.barcodeNoOld == null
                          "
                        >
                          {{ row.barcodeNo }}
                        </td> 
                        <td class="text-center stock-item-td" 
                        v-if="
                            row.barcodeNoOld != null
                          ">
                          {{ row.barcodeNoOld }}
                        </td>
                        
                        <td class="text-center stock-item-td">
 
                          <a
                            href="#"
                            @click.prevent="pictureModal(row.fileUrl)"
                            title="รูปภาพ"
                            v-if="row.fileUrl != null && !row.isImgCloud"
                            >Link  </a
                          >
                          <a
                            href="javascript:void(0);"
                             @click="showModal(row.fileUrl)"
                            title="รูปภาพ"
                            v-if="row.fileUrl != null && row.isImgCloud"
                            >Link </a
                          >
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

         
          
          <div class="row" >
              <div class="col-xl-3 text-left">
                <h3 v-if="barcodeBrands!=null && barcodeBrands.length > 0" class="kt-section__title">
                  แบรนด์ 
                </h3> 
              </div>
              <div class="col-xl-3 text-right">
                <button
                  type="button"
                  class="btn btn-outline-brand"
                  data-dismiss="modal" 
                  v-if="isPM"
                  @click="detailPM(checkInId,pmSurveyCheckInId)"
                >
                  <i class="la la-file-text"></i> รายละเอียด PM
                </button>  
                 
              </div>
            </div>
          <table
                    class="table table-sm table-striped table-bordered table-hover table-checkable w-50"
                  >
                    <thead>
                      <tr> 
                        <th class="text-center" width="20%">ชื่อ</th> 
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(br, k) in  barcodeBrands" :key="k"> 
                        <td class="stock-item-td text-center">
                          {{ br.brandName }}  
                        </td> 
                      </tr>
                    </tbody>
                  </table>
            
          </div>
      </div>
 

      <div class="modal fade" id="imageModal" tabindex="-1" role="dialog" aria-labelledby="imageModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
          <div class="modal-content mr-4">
            <div class="modal-header">
              <h5 class="modal-title">ภาพถ่าย</h5>
              <button type="button" class="close" aria-label="Close" @click="closeModal">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body"> 
              <img :src="modalImageURL" class="img-thumbnail mb-3" style="height: auto; width: auto;"> 
            </div>
            <div class="modal-footer">
              <button type="button" data-dismiss="modal" class="btn btn-secondary"  aria-label="Close" @click="closeModal"><i class="la la-close"></i> ปิดหน้าต่าง
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="kt-portlet__foot">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="$router.go(-1)"
        >
          <i class="la la-close"></i> ย้อนกลับ
        </button>
      </div>
    </form>
    <!--end::Form-->
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import router from "../../router";

export default {
  data: function() {
    var self = this;
    return {
      barcodeShopMappings: [],
      barcodeShopMappingsOther : [],
      barcodeBrands: [],
      modalImageURL: '',
      shopName: null,
      shopName2: null,
      checkInDate: null,
      checkOutDate: null, // CR-PM-2026 Req 2
      checkInByUserFullName: null,
      checkInId : null,
      pmSurveyCheckInId : null,
      isPM : false
      
    };
  },
  async mounted() {
    let self = this;
    let router = this.$router;
    let user = await this.$root.getUser();

    KTApp.blockPage({
      opacity: 0.05,
      message: "กำลังดึงข้อมูล กรุณารอสักครู่...",
    });

    axios
      .get("/Api/PMSurvey/PMSurveyCheckIn/" + this.$route.params.id)
      .then(function(response) {
        if (response.status == 200) {
          console.log(response.data);
          self.checkInByUserFullName = response.data.checkInByUserFullName;
          self.checkInDate = response.data.checkInDateFormat;
          self.checkOutDate = response.data.quitShopDateFormat || ''; // CR-PM-2026 Req 2
          self.shopName = (response.data.agentTypeCode == "AGENT")  ? response.data.shopName : response.data.subAgentShopName  ;
          self.shopName2 = (response.data.agentTypeCode == "AGENT")  ?response.data.shopName2 : response.data.subAgentShopName2;
          self.checkInId = response.data.checkInId;
          self.pmSurveyCheckInId = response.data.pmSurveyCheckInId;
          self.isPM = response.data.isPM ;
        } else {
          Swal.fire(
            "เกิดข้อผิดพลาด",
            "ไม่พบข้อมูล Check-In ร้านค้าที่คุณเลือก",
            "warning"
          );
          router.go(-1);
        }
      })
      .catch(function(error) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูล Check-In ร้านค้าได้ในขณะนี้",
          "error"
        );
        router.go(-1);
      })
      .then(function() {
        // always executed
        KTApp.unblockPage();
      });


    axios
      .get(
        "/Api/PMSurvey/BarcodeMapping/GetAll?ShopId=" +
       // "/Api/PMSurvey/BarcodeMapping/GetAll?ShopId=" +
          this.$route.params.id2 +
          "&PMSurveyCheckInId=" +
          this.$route.params.id + 
          "&SubAgentShopId="+
          this.$route.params.id3 
      )
      .then(function(response) {

        console.log(response.data );

        if (response.status == 200) {
          //console.log(response.data.data.length);

          

          if (response.data != null && response.data.length > 0) {
            for (var i = 0; i < response.data.length; i++) {
              let el = response.data[i];



              //loop barCodeSet
              let barcodeSets = [];

              
              if (el.barcodeSets != null && el.barcodeSets.length > 0   ) {
 
                el.barcodeSets.forEach((el2) => {
                  //loop brand
                  let brand = "";
                  if (el2.brand != null && el2.brand.length > 0) {
                    el2.brand.forEach((el3) => {
                      if (brand != "") brand += ", ";

                      // brand += "[" + el3.brandId + "] " + el3.brandName;
                      brand += el3.brandName;
                    });
                  } 
                  barcodeSets.push({ 
                    barcodeId: el2.barcodeId,
                    barcodeNo: el2.barcodeNo,
                    barcodeNoOld: el2.barcodeNoOld,
                    barcodeType: el2.barcodeType,
                    barcodeSubTypeName: el2.barcodeSubTypeName,
                    isBarButler: el2.isBarButler,
                    isCoolRoom: el2.isCoolRoom,
                    isPersonalDispenser: el2.isPersonalDispenser,
                    nfcCode: el2.nfcCode,
                    productId: el2.productId,
                    productName: el2.productName,
                    brand: brand,
                    fileUrl: el2.fileUrl,
                    isImgCloud : (el2.isImgCloud!=null && el2.isImgCloud!=undefined) ? el2.isImgCloud : false,
                  });
                });

                console.log(barcodeSets)
                 
                if(el.groupId == 0){
                  self.barcodeShopMappingsOther.push({
                    groupName : el.groupName,
                    groupId : el.groupId,
                    barcodeShopMappingId: el.id,
                    barcodeSets: barcodeSets,
                    isPM: el.isPM,
                    isMT: el.isMT,
                    indexDisplay: el.index ,
                    deleteReason: el.deleteReason,
                    isDelete: el.isDelete,
                  }); 
                }
                else{ 
                  self.barcodeShopMappings.push({
                    groupName : el.groupName,
                    groupId : el.groupId,
                    barcodeShopMappingId: el.id,
                    barcodeSets: barcodeSets,
                    isPM: el.isPM,
                    isMT: el.isMT,
                    indexDisplay: el.index ,
                    deleteReason: el.deleteReason,
                    isDelete: el.isDelete,
                  }); 
              }

              }

              self.barcodeShopMappings.sort(function(a, b) {
                return a.groupName ;
              });

              if (response.data != null && response.data.length > 0) {
                self.barcodeBrands = response.data[0].brands ;
              } 

              
            }
          }
          //console.log(self.barcodeShopMappings);
        } else {
          Swal.fire(
            "เกิดข้อผิดพลาด",
            "ไม่พบข้อมูล Check-In ร้านค้าคุณเลือก",
            "warning"
          );
          router.go(-1);
        }
      })
      .catch(function(error) {
        console.log(error);
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูล Check-In ร้านค้าได้ในขณะนี้",
          "error"
        );
        router.go(-1);
      })
      .then(function() {
        // always executed
        KTApp.unblockPage();
      });
  },
  methods: {
    showModal(imageURL) {
    
      this.modalImageURL = imageURL;
      this.isFromImageModal = true;
      $('#imageModal').modal('show');
      $('#imageModal').on('hidden.bs.modal', () => {
        $('body').addClass('modal-open');
      });
    },
    closeModal() {
      $('#imageModal').modal('hide');
    },
    barcodeTypeText(barcodeType,barcodeSubTypeName) {
      if (barcodeType == "BARCODE_TYPE_COOL_ROOM") return "ห้อง Cool Room";
      else if (barcodeType == "BARCODE_TYPE_DISPENSER") return "หัวจ่าย";
      else if (barcodeType == "BARCODE_TYPE_REGULATOR_JUMP") return barcodeSubTypeName;
      else if (barcodeType == "BARCODE_TYPE_REGULATOR") return barcodeSubTypeName;
      else if (barcodeType == "BARCODE_TYPE_MACHINE") return "เครื่องเบียร์สด";
      else if (barcodeType == "BARCODE_TYPE_PERSONAL_DISPENSER")
        return "หัวจ่ายส่วนบุคคล";
    },
    detailPM(checkInId,pmSurveyCheckInId) { 
      router.push({
        path: `/PM/PMSurveyCheckIn/${checkInId}/PMSurveyDetail/${pmSurveyCheckInId}`,
      });
    },
    // detailMT(barcodeShopMappingId) {
    //   router.push({
    //     path: `/PM/PMCheckIn/${this.$route.params.id}/MTDetail/${barcodeShopMappingId}`,
    //   });
    // },
    pictureModal(fileUrl) {
      let router = this.$router;
      var url = `/PM/PMCheckIn/${this.$route.params.id}/BarcodeMappingDetail/${this.$route.params.id2}/${this.$route.params.id3}/Picture/${encodeURIComponent(fileUrl)}` ;
      if (fileUrl != null) {
        router.push({
          path: url,
        });
      } else Swal.fire("เกิดข้อผิดพลาด", "กรุณาคลิก Link", "error");
    }, 
  },
};
</script>
<style lang="css">
.stock-item-td {
  color: #6c7293;
}
</style>



// WEBPACK FOOTER //
// App/Components/PM/PMSurveyBarcodeMappingDetail.vue